import React, { Component, Suspense, lazy } from "react";
import { Link } from "react-router-dom";
import { bannerMonitoredData } from "../../actions/common.action";
import { formatNumberOnDashBoard, getLocalstorage } from "../../helper";
// import { get } from "lodash";
import { Image, Form } from "react-bootstrap";
// import PmgModal from "./PmgModal";
// import PmgMechanismModal from "./PmgMechanismModal";
// import PmgTeamModal from "./PmgTeamModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ReactPlayer from "react-player";
import screenfull from "screenfull";
import { findDOMNode } from "react-dom";
import CountUp from "react-countup";
import YTIcon from "../../assets/youtube 1.svg";
import thumbPMG from "../../assets/thumbPMG.webp";
import { PATHS } from "../../constant";
const PmgModal = lazy(() => import("./PmgModal"));
const PmgMechanismModal = lazy(() => import("./PmgMechanismModal"));
const PmgTeamModal = lazy(() => import("./PmgTeamModal"));
const NeedHelpModal = lazy(() => import("./NeedHelpModal"));
class Banner extends Component {
  videoUrl = "https://www.youtube.com/embed/OjK8eKfEhco";
  hindiVideoUrl = "https://www.youtube.com/embed/-85C4bVVfeQ";
  // videoUrl = "https://www.youtube.com/embed/wtjB3CCfvoY";
  //videoUrl = "https://www.youtube.com/embed/FUiu-cdu6mA";
  state = {
    monitoredData: {},
    isBannerModalVisible: false,
    bannerContent: "",
    pauseVideos: false,
    muted: true,
    loop: 1,
    videoArr: Array(1).fill(this.videoUrl),
    hindiVideoArr: Array(1).fill(this.hindiVideoUrl),
    updateValues: 0,
    videoSwitch: false,
    isModalVisible: false,
    modalContent: "",
    playerStarted: false
  };

  componentDidMount() {
    window && window.addEventListener("scroll", this.onScroll);
    this.getBannerMonitoredData();
  }

  toggleChange = () => {
    this.setState({ videoSwitch: !this.state.videoSwitch });
  };
  onScroll = () => {
    let currentOffset = (window && window.scrollY) || 0;
    if (
      (currentOffset > 75 && currentOffset < 110) ||
      (currentOffset > 710 && currentOffset < 736)
    ) {
      this.setState({
        updateValues: Math.random()
      });
    }
  };

  getBannerMonitoredData = async () => {
    let response = await bannerMonitoredData();
    if (response && response.status) {
      this.setState({ monitoredData: response.data.data });
    }
  };

  closeReadBannerModal = () => {
    this.setState({ isBannerModalVisible: false, bannerContent: "" });
  };

  showReadBannerModal = key => {
    this.setState({ isBannerModalVisible: true, bannerContent: key });
  };

  onClickFullscreen = () => {
    screenfull.request(findDOMNode(this.refs.player));
  };

  muteAudio = () => {
    this.setState({
      muted: !this.state.muted
    });
  };

  controlVideo = () => {
    this.setState({
      pauseVideos: !this.state.pauseVideos,
      playerStarted: !this.state.playerStarted
    });
  };

  componentWillUnmount() {
    window && window.removeEventListener("scroll", this.onScroll);
  }

  /**
   * For Looping the same video again.
   */
  onEnd = () => {
    this.setState({
      loop: this.state.loop === 3 ? 1 : ++this.state.loop,
      videoArr: Array(this.state.loop).fill(this.videoUrl)
    });
  };
  onHindiVideoEnd = () => {
    this.setState({
      loop: this.state.loop === 3 ? 1 : ++this.state.loop,
      hindiVideoArr: Array(this.state.loop).fill(this.hindiVideoArr)
    });
  };

  showModal = key => {
    this.setState({ isModalVisible: true, modalContent: key });
  };

  closeModal = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    const {
      monitoredData,
      bannerContent,
      isBannerModalVisible,
      muted,
      pauseVideos,
      loop,
      updateValues,
      videoArr,
      videoSwitch,
      isModalVisible,
      modalContent
    } = this.state;

    let isLoggedIn = !!getLocalstorage("token");

    let pmgInvestIndiaMail = isLoggedIn
      ? "pmg@investindia.org.in"
      : "pmg[at]investindia[dot]org[dot]in";

    let pmgSupportMail = isLoggedIn
      ? "pmg-support@investindia.org.in"
      : "pmg-support[at]investindia[dot]org[dot]in";

    return (
      <React.Fragment>
        <div className={`banner-wrapper`} id="home">
          <div className="container" style={{ marginTop: "-90px" }}>
            {/* <div
              className="toll-no"
              style={{
                height: "30px",
                display: "flex",
                position: "absolute",
                justifyContent: "flex-end",
                top: "102px",
                right: "22px",
                cursor: "pointer"
              }}
              onClick={() => this.showModal("needHelp")}
            >
              <button className="btn-ctct-icon btn-contact-us">
                <img src={ContactUs} alt="" />
                <span> Contact Us </span>
              </button>
            </div> */}
            <div className="banner-text">
              <h1>Project Monitoring Group</h1>
              {/* <p> */}
              <span className="sub-banner-text">
                Enabling faster project implementation through coordinated
                monitoring and timely action.
              </span>
              {/* <span
                  className="read-more"
                  onClick={() => this.showReadBannerModal("aboutPmg")}
                >
                  {" "}
                  ...Read More{" "}
                </span> */}
              {/* </p> */}
              <div className="button-group">
                <Link to={PATHS.ABOUT_US_PAGE}>
                  <button
                    className="btn pmg-team-btn"
                    data-test="pmg-team-button"
                    // onClick={() => this.showReadBannerModal("pmgTeam")}
                  >
                    Know More
                  </button>
                </Link>
                <button
                  className="btn pmg-mechanism-btn"
                  data-test="pmg-mechanism-button"
                  onClick={() => this.showReadBannerModal("pmgTeam")}
                >
                  PMG Team
                </button>
                {/*<Link to={PATHS.LOGIN} className="btn btn-pink no-padding">*/}
                {/*Create Project & Add Issues*/}
                {/*</Link>*/}
                {/*<Button className="btn-white-invert no-padding watch-demo">
                  <div className="play-icon" />
                  Watch Demo
                </Button>*/}
              </div>
            </div>
            <div style={{ height: "60%" }}>
              <Image src={YTIcon} className="landingpage-yticon" />
              <span className="youtube-video-engtext">English</span>
              <div className="toogle_switch youtube-video-toggle">
                <Form.Check className="d-flex" style={{ paddingLeft: 0 }}>
                  <Form.Check.Input
                    type="checkbox"
                    checked={videoSwitch}
                    onChange={() => this.toggleChange()}
                  />
                  <Form.Check.Label onClick={() => this.toggleChange()} />
                  <span className="youtube-video-hinditext">Hindi</span>
                </Form.Check>
              </div>

              <div className="video-wrapper" data-test="video-wrapper">
                <ReactPlayer
                  url={videoSwitch ? this.hindiVideoUrl : this.videoUrl}
                  ref="player"
                  muted={muted}
                  loop={true}
                  playing={!pauseVideos || this.state.playerStarted}
                  onEnded={videoSwitch ? this.onHindiVideoEnd : this.onEnd}
                  light={!this.state.playerStarted ? thumbPMG : false}
                />
                <div className="controls play-icons">
                  <span
                    onClick={() => this.controlVideo()}
                    className={"play-video " + (!pauseVideos ? "pause" : "")}
                  >
                    play/pause
                  </span>
                  <span
                    onClick={this.muteAudio}
                    className={"mute-video " + (muted ? "" : "mute")}
                  >
                    Mute
                  </span>
                  <span onClick={this.onClickFullscreen} className="full-video">
                    FullScreen
                  </span>
                </div>
                <div
                  className="black-bar"
                  onClick={() => this.controlVideo()}
                />
              </div>
            </div>
          </div>
          <div className="banner-card container">
            <div className="banner-card-data">
              <div className="dashboard-graph project-monitored">
                <div className="summary-total">
                  <b>
                    {monitoredData && monitoredData.projectMonitored ? (
                      <CountUp
                        start={updateValues}
                        end={monitoredData.projectMonitored}
                        delay={0}
                        formattingFn={n => Number(n.toFixed(1))}
                        duration={2.75}
                      >
                        {({ countUpRef }) => (
                          <div>
                            <span
                              data-test="projects-monitored"
                              ref={countUpRef}
                            />
                          </div>
                        )}
                      </CountUp>
                    ) : (
                      "0"
                    )}
                  </b>
                </div>
                <div
                  className="summary-label"
                  data-test="projects-monitored-label"
                >
                  Projects Monitored
                </div>
              </div>
            </div>
            <div className="banner-card-data">
              <div className="dashboard-graph project-value color-blue">
                <div className="summary-total">
                  <b>
                    {monitoredData && monitoredData.projectValue ? (
                      <CountUp
                        start={updateValues}
                        end={monitoredData.projectValue}
                        delay={0}
                        formattingFn={n =>
                          formatNumberOnDashBoard(
                            Number(n.toFixed(1)),
                            true,
                            true,
                            "."
                          )
                        }
                        duration={2.75}
                      >
                        {({ countUpRef }) => (
                          <React.Fragment>
                            <OverlayTrigger
                              overlay={
                                <Tooltip className="my-tooltip-1 project-val-tooltip">
                                  &#x20B9;{" "}
                                  {monitoredData.projectValue &&
                                    parseInt(monitoredData.projectValue)}{" "}
                                  Cr.
                                </Tooltip>
                              }
                            >
                              <div>
                                <span
                                  data-test="projects-value"
                                  ref={countUpRef}
                                />
                              </div>
                            </OverlayTrigger>
                          </React.Fragment>
                        )}
                      </CountUp>
                    ) : (
                      "0"
                    )}
                  </b>
                </div>
                <div className="summary-label" data-test="project-value-label">
                  Project Value
                </div>
              </div>
            </div>
            <div className="banner-card-data">
              <div className="dashboard-graph issue-monitored color-teal">
                <div className="summary-total">
                  <b>
                    {monitoredData && monitoredData.issueMonitored ? (
                      <CountUp
                        start={updateValues}
                        end={monitoredData.issueMonitored}
                        delay={0}
                        useEasing={true}
                        formattingFn={n => Number(n.toFixed(1))}
                        duration={2.75}
                      >
                        {({ countUpRef }) => (
                          <div>
                            <span
                              data-test="issues-monitored"
                              ref={countUpRef}
                            />
                          </div>
                        )}
                      </CountUp>
                    ) : (
                      "0"
                    )}
                  </b>
                </div>
                <div
                  className="summary-label"
                  data-test="issues-monitored-label"
                >
                  Issues Monitored
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*<Modal show={true} className="front-video">
          <Modal.Header closeButton />
          <Modal.Body>
            <Player
            playsInline
            autoPlay
            src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
          />
          </Modal.Body>
        </Modal>*/}
        {/* {bannerContent === "aboutPmg" ? (
          <Suspense fallback={<div>Loading modal...</div>}>
            <PmgModal
              show={isBannerModalVisible}
              closeModal={this.closeReadBannerModal}
            />
          </Suspense>
        ) : null} */}
        {bannerContent === "mechanism" ? (
          <Suspense fallback={<div>Loading modal...</div>}>
            <PmgMechanismModal
              show={isBannerModalVisible}
              closeModal={this.closeReadBannerModal}
            />
          </Suspense>
        ) : null}
        {bannerContent === "pmgTeam" ? (
          <Suspense fallback={<div>Loading modal...</div>}>
            <PmgTeamModal onClose={this.closeReadBannerModal} />
          </Suspense>
        ) : null}
        {modalContent === "needHelp" ? (
          <Suspense fallback={<div>Loading modal...</div>}>
            <NeedHelpModal
              show={isModalVisible}
              closeModal={this.closeModal}
              pmgInvestIndiaMail={pmgInvestIndiaMail}
              pmgSupportMail={pmgSupportMail}
            />
          </Suspense>
        ) : null}
      </React.Fragment>
    );
  }
}

export default Banner;
